module.exports = __webpack_public_path__ + "assets/img/block-25689eb9.png";